'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { useServicePurchaseStep } from '@/modules/service-purchase/providers/service-purchase-store-provider';
import { ServicePurchaseStep } from '@/modules/service-purchase/types';
function SelectOperatorAction() {
  const $ = _c(4);
  const {
    goToStep
  } = useServicePurchaseStep();
  let t0;
  if ($[0] !== goToStep) {
    t0 = function handleSelectOperator() {
      goToStep(ServicePurchaseStep.SelectOperator);
    };
    $[0] = goToStep;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleSelectOperator = t0;
  let t1;
  if ($[2] !== handleSelectOperator) {
    t1 = <div className="flex w-full justify-end"><Button variant="default" onClick={handleSelectOperator}>Select an operator</Button></div>;
    $[2] = handleSelectOperator;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export { SelectOperatorAction };